import React from 'react'
import ReactDOM from 'react-dom'
import {
 BrowserRouter,
 Switch,
 Route
} from 'react-router-dom'
import { CookiesProvider } from 'react-cookie'

import Login from './components/admin/login'
import Inbox from './components/admin/inbox'
import Users from './components/admin/users'
import Settings from './components/admin/settings'
import Welcomepagesettings from './components/admin/welcomepagesettings'
import ImpressumConfig from './components/admin/impressumconfig'

import { default as rootStore } from './stores/storeHolder'

import Start from './components/start'
import Page404 from './components/404'
import ExampleDetails from './components/exampledetails'
import Collection from './components/collection'
import Impressum from './components/impressum'
import Datenschutz from './components/datenschutz'
import PDFCollectionPupils from './components/PDFCollectionPupils'
import PDFCollectionTeacher from './components/PDFCollectionTeacher'
import PDFCollectionPupilsAndTeacher from './components/PDFCollectionPupilsAndTeacher'
import AboutSoftware from './components/aboutsoftware'

import { withAuthorization} from './utils/hoc'
import  { observer, Provider } from 'mobx-react'

import T from 'i18n-react'
import moment from 'moment'
import * as locales from 'moment/min/locales'
import route from './stores/fetchconfig.json'

const textDE = require('./locales/de.json')
T.setTexts(textDE)

moment.locale('de')


@observer
class App extends React.Component {
 render() {
  return (
   <BrowserRouter>
    <Provider {...rootStore}>
     <CookiesProvider>
       <div>

        <Switch>
         <Route exact path={route.endpoint + '/'} component={Start} />
         <Route path={route.endpoint + '/collection'} component={Collection} />
         <Route path={route.endpoint + '/impressum'} component={Impressum} />
         <Route path={route.endpoint + '/datenschutz'} component={Datenschutz} />
         <Route path={route.endpoint + '/aboutsoftware'} component={AboutSoftware} />
         <Route path={route.endpoint + '/admin/inbox'} component={withAuthorization(Inbox)} />
         <Route path={route.endpoint + '/admin/users'} component={withAuthorization(Users)} />
         <Route path={route.endpoint + '/admin/settings'} component={withAuthorization(Settings)} />
         <Route path={route.endpoint + '/admin/welcomepagesettings'} component={withAuthorization(Welcomepagesettings)} />
         <Route path={route.endpoint + '/admin/impressumconfig'} component={withAuthorization(ImpressumConfig)} />
         <Route path={route.endpoint + '/pdf/collection/pupils'} component={PDFCollectionPupils} />
         <Route path={route.endpoint + '/pdf/collection/teacher'} component={PDFCollectionTeacher} />
         <Route path={route.endpoint + '/pdf/collection/pupilsandteacher'} component={PDFCollectionPupilsAndTeacher} />
         <Route exact path={route.endpoint + '/:id/:title'} component={ExampleDetails} />
         <Route path={route.endpoint + '/admin'} component={Login} />
         <Route path='*' component={Page404} />
        </Switch>

       </div>
     </CookiesProvider>
    </Provider>
   </BrowserRouter>
  )
 }
}

ReactDOM.render(<App/>, document.getElementById('app'))



// WEBPACK FOOTER //
// ./src/index.js